var _circle, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDelivery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#DCEFE1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.35645 8.56445V14.3869H7.17085C7.17085 13.6013 7.80925 12.9645 8.59325 12.9645C9.37725 12.9645 10.0156 13.6013 10.0156 14.3869H13.5052V8.56445H6.35645Z",
    fill: "#004C3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7679 12.0531V14.3875H17.2463C17.2463 13.6019 16.6095 12.9651 15.8239 12.9651C15.0383 12.9651 14.4015 13.6019 14.4015 14.3875H13.8799V9.73633H15.1167C15.7471 9.73633 16.2559 10.2467 16.2559 10.8755V11.2547C16.2559 11.3859 16.3615 11.4915 16.4895 11.4915H17.2031C17.5119 11.4915 17.7647 11.7427 17.7647 12.0531H17.7679Z",
    fill: "#004C3B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8719 14.3869C16.8719 14.9661 16.4031 15.4349 15.8239 15.4349C15.2447 15.4349 14.7759 14.9661 14.7759 14.3869C14.7759 13.8077 15.2447 13.3389 15.8239 13.3389C16.4031 13.3389 16.8719 13.8077 16.8719 14.3869Z",
    fill: "#004C3B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2048 10.8496H16.8976C16.8832 9.88001 16.0896 9.096 15.1168 9.096H14.1456V7.9248H5.7168V15.0272H7.0336C7.2928 15.6592 7.9056 16.0752 8.5936 16.0752C9.2816 16.0752 9.896 15.6592 10.1552 15.0272H14.264C14.5232 15.6592 15.136 16.0752 15.824 16.0752C16.512 16.0752 17.1264 15.6592 17.384 15.0272H18.408V12.0528C18.408 11.3888 17.8688 10.8496 17.2048 10.8496ZM18.088 14.7072H17.1584L17.1216 14.8176C16.9344 15.3776 16.4144 15.7552 15.824 15.7552C15.2336 15.7552 14.7136 15.3776 14.5264 14.8176L14.4912 14.7072H9.928L9.8912 14.8176C9.7056 15.3776 9.184 15.7552 8.5936 15.7552C8.0032 15.7552 7.4832 15.3776 7.2976 14.8176L7.2608 14.7072H6.0368V8.2448H13.8256V9.416H15.1168C15.9216 9.416 16.5776 10.0704 16.5776 10.8752V11.1696H17.2048C17.6912 11.1696 18.088 11.5664 18.088 12.0528V14.7072Z",
    fill: "#004C3B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64141 14.3869C9.64141 14.9661 9.17101 15.4349 8.59341 15.4349C8.01581 15.4349 7.54541 14.9661 7.54541 14.3869C7.54541 13.8077 8.01421 13.3389 8.59341 13.3389C9.17261 13.3389 9.64141 13.8077 9.64141 14.3869Z",
    fill: "#004C3B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelivery);
export default __webpack_public_path__ + "static/media/IconDelivery.16d044b46814fc3a7274da802277bab8.svg";
export { ForwardRef as ReactComponent };